<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M25.5 3.52073L40.9856 12.4613C41.9138 12.9972 42.4856 13.9876 42.4856 15.0594V32.9406C42.4856 34.0124 41.9138 35.0028 40.9856 35.5387L25.5 44.4793C24.5718 45.0152 23.4282 45.0152 22.5 44.4793L7.01443 35.5387C6.08623 35.0028 5.51443 34.0124 5.51443 32.9406V15.0594C5.51443 13.9876 6.08623 12.9972 7.01443 12.4613L22.5 3.52073C23.4282 2.98483 24.5718 2.98483 25.5 3.52073Z"
        stroke="var(--icon-color)" stroke-width="2" />
    <path d="M30.5699 10.9586L33.6428 12.7533M37.6607 15.0505L33.6428 12.7533M33.6428 12.7533V34.9568" stroke="var(--icon-color)"
        stroke-width="1.5" />
    <path
        d="M20.7857 38.5379L20.7857 23.6236M28.7451 10.0227L24 7.125L20.7857 9.06288L20.7857 23.6236M20.7857 23.6236H25.5023"
        stroke="var(--icon-color)" stroke-width="1.5" />
    <path d="M9.53571 32.1349V15.3146L15.9643 35.628L15.9716 11.7265" stroke="var(--icon-color)" stroke-width="1.5" />
</svg>
